const ShareFeedbackSection = () => {
    return (
        <section className="basic-area share-qr-area">
            <div className="container">
                <div className="basic-flex basic-flex--reverse share-qr">
                    <img
                        className="basic-flex__image"
                        src="/images/feedback.gif"
                        alt="share QR"
                    />

                    <div className="basic-flex__content">
                        <h2>Get more feedback with quick and easy rating questions</h2>

                        <div>
                            <strong>QR Code , Short URL or NFC Card </strong> for quick survey access.<br /><br /> We use Likert questions to gather user sentiment and feedback to put together a Likert scale.  Katalife presents a statement and asks respondents to indicate their level of agreement or disagreement on a symmetric scale, ranging from “strongly disagree” to “strongly agree.”
                            <br /><br></br><h3 className="navgreen mobile-center">Go ahead and give it a try</h3><br />
                            <div className="demo-qr-code-container" >
                                <div className="qr-code-box" style={{ width: "120px", height: "140px", }}>
                                    <a href="https://www.kata.life/feedback/EgBke" style={{ fontSize: "11px", textAlign: "center" }} target="_blank" rel="noopener noreferrer" >
                                        <img style={{ minWidth: "100px"}} src="/images/katalife-qr-code-demo-cafe.png" alt="Katalife demo cafe survey QR Code" />
                                        click or scan </a>
                                </div>
                                <span style={{ paddingLeft: "20px" }}>Restaurant / Cafe</span>
                            </div>
                            <div className="demo-qr-code-container" >
                                <div className="qr-code-box" style={{ width: "120px", height: "140px" }}>
                                    <a href="https://www.kata.life/feedback/icmmQ" style={{ fontSize: "11px", textAlign: "center" }} target="_blank" rel="noopener noreferrer" >
                                        <img style={{ minWidth: "100px"}} src="/images/katalife-qr-code-demo-presentation.png" alt="Katalife demo presentation survey QR Code" />
                                        click or scan </a>
                                </div>
                                <span style={{ paddingLeft: "20px" }}> Presentation </span>
                            </div>
                            <div className="demo-qr-code-container" >
                                <div className="qr-code-box" style={{ width: "120px", height: "140px" }}>
                                    <a href="https://www.kata.life/feedback/icmmQ" style={{ fontSize: "11px", textAlign: "center" }} target="_blank" rel="noopener noreferrer" >
                                        <img style={{ minWidth: "100px"}} src="/images/katalife-qr-code-demo-360feedback.png" alt="Katalife demo 360 feedback survey QR Code" />
                                        click or scan </a>
                                </div>
                                <span style={{ paddingLeft: "20px" }}> 360 Feedback / Peer feedback </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShareFeedbackSection;
